// test505
(505 && 0);
